module.exports = __webpack_public_path__ + "static/media/solar_states.a5367ea5.jpg";